// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonHelper } from '../../../../core/_config/common.helper';
import { LoginService } from './services/login.service';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { encrypt } from '../../../../utilities/utilityFunctions';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { MapsAPILoader } from '@agm/core';
import { GoogleAnalyticsService } from '../../../../shared/sharedServices/google-analytics.service';
import { environment } from '../../../../../environments/environment.prod';

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	public loginForm: FormGroup;
	public loading: boolean;
	public emailDropdownOption: any = [];
	model = {
		latitude: 0,
		longitude: 0
	};
	userDetail = {
		lng: '',
		lat: '',
		ip: '',
		city: '',
		country: '',
		isp: ''
	}
	geoCoder;
	currentLatitude: number = 0;
	currentLongitude: number = 0;
	currentAddress: string = '';
	desiredAddress: string = '';
	@ViewChild('search', { static: true }) searchElementRef: ElementRef;

	public emailVerified: boolean = false;
	public loginPayload: any;
	public errorMsg: string;
	public isError: boolean = false;
	public alertType: string;
	public phide: boolean = true
	constructor(
		private router: Router,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
		private loginService: LoginService,
		private sharedServices: SharedService,
		private mapsAPILoader: MapsAPILoader,
		private route: ActivatedRoute,
		private gaService: GoogleAnalyticsService,
	) {
		this.initLoginForm();
		this.getIpLocation();
		this.mapsAPILoader.load().then(() => {
			this.setLocation();
			this.geoCoder = new google.maps.Geocoder;
		});
		this.route.queryParams.subscribe(params => {
			const ref = params['ref'];
			if (ref == 'research') {
				let details = JSON.parse(localStorage.getItem('loginDetails'))
				if (details['userName'] && details['password']) {
					this.loginForm.controls.email.patchValue(details['userName'])
					this.loginForm.controls.password.patchValue(details['password'])
				}
				this.submitLogin();
			}
		});

	}

	ngOnInit() {
		this.gaService.setPage('/login', 'Login');
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (document.getElementById('km-loginscreen')) document.getElementById('km-loginscreen').classList.add('active');
		}, 100);
	}

	ngOnDestroy(): void {
		this.loading = false;
	}

	public initLoginForm() {
		this.loginForm = this.fb.group({
			email: ['', Validators.compose([
				Validators.required,
				Validators.maxLength(50)
			])
			],
			password: ['', Validators.compose([
				Validators.minLength(8),
				Validators.maxLength(20)
			])
			]
		});
	}

	public verifyLogin(): void {
		this.markFormsTouched(this.loginForm)
		if (this.loginForm.valid) {
			this.loading = true;
			let payload = {
				data: this.loginForm.controls.email.value
			}
			this.loginService.verifyUserId(payload).subscribe(
				(res) => {
					if (res == null) {
						this.loading = false;
						this.emailDropdownOption = [];
						this.emailDropdownOption.push({ value: payload.data, label: payload.data })
						this.emailDropdownOption.push({ value: 'OtherOption', label: 'Use another account' })
						this.cdr.detectChanges();
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.emailVerified = true;
						this.loading = false;
						this.isError = false;
						this.cdr.detectChanges();
						this.emailDropdownOption = [];
						this.emailDropdownOption.push({ value: payload.data, label: payload.data })
						this.emailDropdownOption.push({ value: 'OtherOption', label: 'Use another account' })
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BUSINESS_ERROR) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.LOCKED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.BLACKLISTED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.UNVERIFIED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
					else {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
				}, (err) => {
					this.isError = true;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_ACCOUNT;
					this.loading = false;
					this.cdr.detectChanges();
				})

		}
	}


	public submitLogin(): void {
		this.markFormsTouched(this.loginForm)
		if (this.loginForm.valid) {
			this.loading = true;
			this.loginPayload = {
				username: this.loginForm.controls.email.value,
				password: this.loginForm.controls.password.value
			}
			const authPayload = {
				data: this.userDetail,
				userName: this.loginForm.controls.email.value,
				password: this.loginForm.controls.password.value
			}
			let userDetails = {
				data: this.userDetail
			}
			this.sharedServices.login(this.loginPayload, userDetails).subscribe(
				(res) => {
					if (res == null) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.loading = false;
						this.isError = true;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_PASSWORD;
						this.cdr.detectChanges();
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						let data = encrypt(JSON.stringify(res.data));
						// this.loading = false;
						localStorage.setItem('esp-profile-details', data);
						localStorage.setItem('login', encrypt(JSON.stringify(this.loginPayload)));
						this.cdr.detectChanges();
						let isAdmin = false;
						if (res.data && res.data.getSpRole) {
							const role = res.data.getSpRole.map((x, i) => { return x.find(a => (a == "AD") ? i : null) });
							isAdmin = role && role.length > 0;
							// if (isAdmin == true) {//admin-dashboard
							// 	this.router.navigate(['admin-dashboard']);
							// }
							// else {
								// this.router.navigate(['dashboard']);
							
								// }

							// this below change occurs when to deploy LGSP
							this.sharedServices.authenticate(authPayload).subscribe(
								(res) => {
									this.loading = false;
									if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
										localStorage.setItem(
											environment.JWT,
											res.data.token
										);
										this.router.navigate(['dashboard']);
									}
								}, (err) => {
									this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
									this.isError = true;
									this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_PASSWORD;
									this.loading = false;
									this.cdr.detectChanges();
								});
						
						}
					}
					else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.UNVERIFIED_ACCOUNT) {
						this.isError = true;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.UNVERIFIED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}

					else if (res.errors['Locked'] == HEC_CONSTANTS.HTTP_RESPONSE.ACCOUNT_ERROR) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.LOCKED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}
					else if (res.errors['BlackListed'] == HEC_CONSTANTS.HTTP_RESPONSE.BLACKLISTED_ACCOUNT_ERROR) {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.BLACKLISTED_ACCOUNT;
						this.loading = false;
						this.cdr.detectChanges();
					}

					else {
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isError = true;
						this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_PASSWORD;
						this.loading = false;
						this.cdr.detectChanges();
					}
				}, (err) => {
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					this.isError = true;
					this.errorMsg = HEC_CONSTANTS.ERROR_MESSGAES.AuthMessages.INVALID_PASSWORD;
					this.loading = false;
					this.cdr.detectChanges();
				})

		}
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public ChangeOption(value) {
		if (value == 'OtherOption') {
			this.emailVerified = false;
			this.loginForm.controls.email.patchValue('')
			this.emailDropdownOption = [];
			this.isError = false;
			this.loginForm.controls.password.reset();
		}
	}

	public isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.loginForm.controls[controlName];
		if (!control) {
			return false;
		}
		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	public setLocation(): void {
		this.getCurrentPosition((position, error) => {
			if (position) {
				this.currentLatitude = position.coords.latitude;
				this.currentLongitude = position.coords.longitude;
				this.getCurrentAddress(this.currentLatitude, this.currentLongitude, (address) => {
					this.currentAddress = address;
				});
			}

			this.userDetail.lng = this.currentLongitude.toString();
			this.userDetail.lat = this.currentLatitude.toString();

			this.model = {
				latitude: this.currentLatitude,
				longitude: this.currentLongitude
			}
		});

	}

	public getCurrentPosition(CallBack: Function): void {
		// this.loading = true;
		CommonHelper.getUserCurrentPosition()
			.then((position) => {
				this.loading = false;
				CallBack(position);
			}).catch((error) => {
				this.loading = false;
				CallBack(null);
			});
	}

	public getCurrentAddress(latitude, longitude, CallBack: Function) {
		// this.loading = true;
		this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
			if (status === 'OK') {
				if (results[0]) {
					if (results[0]) {
						results[0].address_components.forEach((element, index) => {
							if (element.types[0] == "country") {
								this.userDetail.country = element.long_name
							}
							if (element.types[0] == "locality") {
								this.userDetail.city = element.long_name
							}
						});
					}
					CallBack(results[0].formatted_address)
				} else {
				}
			} else {
			}
			this.loading = false;
		});
	}

	public getIpLocation() {
		this.loginService.getIpLocation().subscribe(
			(res) => {
				this.userDetail.ip = res.ip;
				this.userDetail.isp = '';
				this.userDetail.city = this.userDetail.city ? this.userDetail.city : res.city;
				this.userDetail.lng = this.currentLongitude ? this.currentLongitude.toString() : res.longitude.toString()
				this.userDetail.lat = this.currentLatitude ? this.currentLatitude.toString() : res.latitude.toString()
				this.userDetail.country = this.userDetail.country ? this.userDetail.country : res.country_name

			}
		)
	}
}
